<template lang="pug">
	span
		span(v-html="currentHtml" v-if="userClicked")
			//- <!--<iframe width="${width}" height="${height}" :src="`https://www.youtube.com/embed/${id}`">-->
			//- <!--</iframe>-->
		span(v-else)
			div(@click="loadYoutube()")
				img(:src="`https://img.youtube.com/vi/${id}/${image}.jpg`")
				span.placeholder-img
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl';

	span
		width: 100%
		display: block
		div
			width: 100%
			display: block
			position: relative
			overflow: hidden
			img
				width: 100%
				cursor: pointer
			span.placeholder-img
				display: block
				width: 80px
				position: absolute
				top: calc(50% - 40px)
				left: calc(50% - 40px)
				height: 56px
				cursor: pointer
				opacity: 0.8
				transition-all()
				background: url('https://web-resources.savingforcollege.com/images/play-btn.png') no-repeat
				background-size: contain
				filter: grayscale(100%)
				background-color: #fff
				border-radius: 15px
			&:hover
				span.placeholder-img
					filter: grayscale(0)
					opacity: 1
</style>

<script>
	export default {

		computed: {},

		props:{
			id: String,
			width: {
				type: String,
				default: '600'
			},
			height: {
				type: String,
				default: '480'
			},
			image: {
				type: String,
				default: 'maxresdefault'
			}
		},

		data(){
			return {
				currentHtml: ``,
				userClicked: false
			}
		},

		methods:{
			loadYoutube(){
				this.currentHtml = `<iframe allow="autoplay" src="https://www.youtube.com/embed/${this.id}?autoplay=1" frameborder="0" allowfullscreen="1" width="${this.width}" height="${this.height}"></iframe>`
				this.userClicked = true
			}
		}
	}
</script>
